export const CART_CHANGE_AMOUNT_ITEM = 'CART_CHANGE_AMOUNT_ITEM'
export const CART_CLEAR_ITEMS = 'CART_CLEAR_ITEMS'

export const SET_CART_VALUES = 'SET_CART_VALUES'
export const CLEAR_CART_VALUES = 'CLEAR_CART_VALUES'